(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtek-standard-engagement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ntReady === 'true') return;
      root.dataset.ntReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-nt-context-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-nt-context-panel]'));
      const activate = (id, focusTab = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.ntContextTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.ntContextPanel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.ntContextTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.ntContextTab, true);
        });
      });
      if (tabs[0]) activate(tabs[0].dataset.ntContextTab);
    };
    document.querySelectorAll('[data-nt-engagement]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-nt-engagement]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtek-standard-processus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ntReady === 'true') return;
      root.dataset.ntReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-nt-process-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-nt-process-panel]'));
      const progress = root.querySelector('[data-nt-process-progress]');
      const activate = (id, focusTab = false) => {
        tabs.forEach((tab, index) => {
          const active = tab.dataset.ntProcessTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && focusTab) tab.focus();
          if (active && progress) progress.style.width = `${((index + 1) / tabs.length) * 100}%`;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.ntProcessPanel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.ntProcessTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.ntProcessTab, true);
        });
      });
      if (tabs[0]) activate(tabs[0].dataset.ntProcessTab);
    };
    document.querySelectorAll('[data-nt-process]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-nt-process]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
